module.exports = __webpack_public_path__ + "img/spitter-die-mask-3.26581de7.png";